import { ParseError } from "./ParseError";
import { accessToken } from "./sessionKey";

//@ts-ignore
import { AxiosInstance, API_ROOT } from "@careinfo/axios-service";

let instance:any;

// Initialize the instance before making any API calls
const initInstance = async () => {
    if (!instance) {
        instance = await AxiosInstance();
    }
};
// Get data from API
export const getApiData = async (url, param = null) => {
    await initInstance();
    let response;
    try {
        response = await instance({
            method: "GET",
            url: `${url}`,
            params: param,
            transformResponse: [
                function (responseData) {
                    // Do whatever you want to transform the data
                    return JSON.parse(responseData);
                },
            ],
        });
    } catch (e) {
        return e.response;
    }
    return response;
};

// Post data to API
export const postApiData = async (data) => {
    const { url, formData, setError } = data;
    await initInstance();
    let response;
    try {
        response = await instance({
            method: "POST",
            url: `${url}`,
            data: formData,
            headers: {
                Authorization: `JWT ${accessToken()}`,
            },
            transformResponse: [
                function (responseData) {
                    // Do whatever you want to transform the data
                    return JSON.parse(responseData);
                },
            ],
        });
    } catch (e) {
        for (const key in e.response?.data) {
            if (e.response?.data.hasOwnProperty(key)) {
                setError(key, { type: 'custom', message: e.response?.data[key] });
            }
        }
        return e.response;
    }
    return response;
};


// Update data
export const patchApiData = async (data) => {
    const { url, formData, setError } = data;
    await initInstance();
    let response;
    try {
        response = await instance({
            method: "PATCH",
            url: `${url}`,
            data: formData,
            headers: {
                Authorization: `JWT ${accessToken()}`,
            },
            transformResponse: [
                function (responseData) {
                    // Do whatever you want to transform the data
                    return JSON.parse(responseData);
                },
            ],
        });
    } catch (e) {
        for (const key in e.response?.data) {
            if (e.response?.data.hasOwnProperty(key)) {
                setError(key, { type: 'custom', message: e.response?.data[key] });
            }
        }
        return e.response;
    }
    return response;
};
// create form data to upload files
export const patchApiFormData = async (data: any) => {
    const { url, formData, setError } = data;
    let response;
    await initInstance();
    try {
      response = await instance({
        method: "PATCH",
        url: `${url}`,
        data: formData,
        headers: {
          "Content-Type": `multipart/form-data`,
  
        },
        transformResponse: [
          function (responseData: any) {
            //Do whatever you want to transform the data
            return JSON.parse(responseData);
          },
        ],
      });
    } catch (e: any) {
      for (const key in e.response?.data) {
        if (e.response?.data.hasOwnProperty(key) && setError) {
          setError(key, { type: 'custom', message: e.response?.data[key] });
        }
      }
      return e.response;
    }
    return response;
  };
  export const postApiFormData = async (data: {
  url: string;
  formData: FormData;
  setError?: any;
}) => {
  await initInstance();
  const { url, formData, setError } = data;
  let response: any;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      transformResponse: [
        function (responseData: any) {
          try {
            return JSON.parse(responseData);
          } catch (e) {
            throw new ParseError(e.message);
          }
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key) && setError) {
        setError(key as any, {
          type: "custom",
          message: e.response?.data[key],
        });
      }
    }
    return e.response;
  }

  return response;
};




export const postFileApiData = async ({
  url,
  formData,
  setError,
  responseType = "json",
}: {
  url: string;
  formData: any;
  setError?: any;
  responseType?: "json" | "blob";
}) => {
  await initInstance();

  const response = await instance({
    method: "POST",
    url,
    data: formData,
    responseType,
    headers: {
      Authorization: `JWT ${accessToken()}`,
      "Content-Type": "application/json",
    },
    transformResponse:
      responseType === "blob"
        ? undefined
        : [(data) => JSON.parse(data)],
  });

  return responseType === "blob" ? response.data : response;
};
// New function for Move or Delete Email API (POST with JSON body)
export const moveOrDeleteEmail = async (data: { email_ids: string[]; action: string,url:string }) => {
  await initInstance();
  // const url = `${API_ROOT}/mailbox/move-or-delete/`;
  const { url, email_ids, action } = data;

  let response:any;
  try {
    response = await instance({
      method: "POST",
      url,
      data:{email_ids,action},
      headers: {
        Authorization: `Token ${accessToken()}`,
        "Content-Type": "application/json",
      },
      transformResponse: [
        function (responseData: any) {
          try {
            return JSON.parse(responseData);
          } catch (e) {
            throw new ParseError((e as Error).message);
          }
        },
      ],
    });
  } catch (e: any) {
    return e.response;
  } 
  return response;
};

// New function for Move to Mailbox API (POST with JSON body)
export const moveToMailbox = async (data: { email_ids: string[]; target_mailbox_id: string,url:string }) => {
  await initInstance();
  // const url = `${API_ROOT}/mailbox/move-to-mailbox/`;
  const { url, email_ids, target_mailbox_id } = data;

  let response:any;
  try {
    response = await instance({
      method: "POST",
      url,
      data: {email_ids,target_mailbox_id},
      headers: {
        Authorization: `Token ${accessToken()}`,
        "Content-Type": "application/json",
      },
      transformResponse: [
        function (responseData: any) {
          try {
            return JSON.parse(responseData);
          } catch (e) {
            throw new ParseError((e as Error).message);
          }
        },
      ],
    });
  } catch (e: any) {
    return e.response;
  }
  
  return response;
};



export { API_ROOT };